import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { postcodeToPostalState } from 'aus-postcode';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { AddressDetailsDialog } from './addressDetailsDialog/addressDetailsDialog';
import { PolicyHolderPropTypes } from '../../../../propTypes/petDetails';
import { SuccessMessageDialog } from '../../../successMessage/successMessageDialog';
import { SUCCESS_MESSAGES } from '../../../../constants/constants';
import './addressDetails.scss';
import { singlePetSuccessMessage } from '../../../../utils/successMessages';

export const AddressDetails = ({ policyHolder, numPolicyHolders = 1 }) => {
  const [isDialogShowing, setIsDialogShowing] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleEditAddress = () => {
    setIsDialogShowing(true);
  };

  const { street, suburb, postcode } = policyHolder;

  const state = postcodeToPostalState(postcode);

  return (
    <div className="policyHolderDetail">
      <div className="personalDetails addressDetails">
        <div className="fieldGroup">
          <div className="labelValueText">
            <span>
              <strong>Street name</strong>
            </span>
            <span>
              <em>{street}</em>
            </span>
          </div>
          <div className="labelValueText">
            <span>
              <strong>Suburb</strong>
            </span>
            <span>
              <em>{suburb}</em>
            </span>
          </div>
          <div className="labelValueText">
            <span>
              <strong>Postcode</strong>
            </span>
            <span>
              <em>{postcode}</em>
            </span>
          </div>
          <div className="labelValueText">
            <span>
              <strong>State</strong>
            </span>
            <span>
              <em>{state.abbreviation}</em>
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={handleEditAddress}
          className="button primary outline"
        >
          <Icon icon="pencil" />
          <span className="labelText">Update</span>
          <span className="sr-only"> address</span>
        </button>
      </div>

      {isDialogShowing && (
        <AddressDetailsDialog
          policyHolder={policyHolder}
          onClose={() => setIsDialogShowing(false)}
          setShowSuccessMessage={setShowSuccessMessage}
        />
      )}
      {showSuccessMessage && (
        <SuccessMessageDialog
          message={`${singlePetSuccessMessage()}${numPolicyHolders > 1 ? SUCCESS_MESSAGES.MULTI_PET : ''}`}
          onClose={() => setShowSuccessMessage(false)}
        />
      )}
    </div>
  );
};

AddressDetails.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  numPolicyHolders: PropTypes.number
};
